import { getToken } from 'data/auth/utils'
import { parseApiEntityData } from 'entities-next/common'
import { EntityId } from 'scenes/Dashboard/data/common/types'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { getUrlWithPathParams } from 'services/api'

import { APIFundingRound, FundingRound, FundingRoundDto } from './fundingRound.types'

const FUNDING_ROUND_ENDPOINT_PATH = 'admin/funding-rounds/'

export function getApiFundingRoundHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const { callApi } = createApiHandler(token, config)

  async function apiGetFundingRounds(organizationId: EntityId): Promise<FundingRound[]> {
    const fundingRounds = await callApi<APIFundingRound[]>({
      url: FUNDING_ROUND_ENDPOINT_PATH,
      params: {
        companyId: organizationId,
        include: ['investments'],
      },
    })
    return fundingRounds.map(parseApiFundingRound)
  }

  async function apiCreateFundingRound(newFundingRound: FundingRoundDto): Promise<FundingRound> {
    const savedFundingRound = await callApi<APIFundingRound>({
      method: 'post',
      url: FUNDING_ROUND_ENDPOINT_PATH,
      data: newFundingRound,
    })

    return parseApiFundingRound(savedFundingRound)
  }

  async function apiUpdateFundingRound(
    fundingRoundId: EntityId,
    fundingRoundData: FundingRoundDto
  ): Promise<FundingRound> {
    const updatedFundingRound = await callApi<APIFundingRound>({
      method: 'patch',
      url: getUrlWithPathParams(FUNDING_ROUND_ENDPOINT_PATH, fundingRoundId),
      data: fundingRoundData,
    })

    return parseApiFundingRound(updatedFundingRound)
  }

  function apiDeleteFundingRound(fundingRoundId: FundingRound['id']): Promise<void> {
    return callApi<void>({
      method: 'delete',
      url: getUrlWithPathParams(FUNDING_ROUND_ENDPOINT_PATH, fundingRoundId),
    })
  }

  return {
    apiGetFundingRounds,
    apiCreateFundingRound,
    apiDeleteFundingRound,
    apiUpdateFundingRound,
  }
}

function parseApiFundingRound({ investments = [], ...otherData }: APIFundingRound): FundingRound {
  return {
    investments: investments.map(parseApiEntityData),
    ...parseApiEntityData(otherData),
  }
}
